import React from 'react';
import { useAppStore } from '../../../../../GlobalStore/GlobalStore';
import { handleLinkClick, clickFileLink } from "../../../../../Utils/misc/openLink.ts";
import { getRelativePath, truncateFileName } from '../../../../../Utils/misc/pathUtils';

interface MetadataContentProps {
    group: any;
}

const MetadataContent: React.FC<MetadataContentProps> = ({ group }) => {
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode, projectName } = environmentObj;

    const formatReference = (reference: string, type: string) => {
        if (type === "file" && reference) {
            const fileName = reference.split(/[/\\]/).pop() || '';
            return truncateFileName(fileName, 35);
        } else if (type === "url") {
            return truncateFileName(reference, 35);
        }
    }

    const added = group.messages[0].metadata.referenceChanges ? group.messages[0].metadata.referenceChanges.added : null;
    const removed = group.messages[0].metadata.referenceChanges ? group.messages[0].metadata.referenceChanges.removed : null;

    return (
        <div className={`pt-1 pb-2  ${environment === "vscode" ? "text-xs" : "text-sm"} text-nowrap flex justify-center items-center`}>
            <div>
                {group.messages[0].metadata.dateToRender && (
                    <div className="text-neutral-600 text-center">
                        {group.messages[0].metadata.dateToRender}
                    </div>
                )}
                {added && added.length > 0 && (
                    <div className="text-green-600 text-center">
                        {added.map((item: any, index: number) => (
                            <div
                                key={index}
                                data-tooltip-id="main-tooltip"
                                data-tooltip-content={item.type === "file" ? getRelativePath(item.path, projectName) : item.path}
                            >
                                {item.type === "url" ? (
                                    <a
                                        href={item.path}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => handleLinkClick(e, environment, vscode, item.path)}
                                    >
                                        {`+ ${formatReference(item.path, item.type)}`}
                                    </a>
                                ) : (
                                    <a
                                        href={item.path}
                                        onClick={(e) => clickFileLink(e, environment, vscode, item.path)}
                                        className="text-green-600"
                                    >
                                        {`+ ${formatReference(item.path, item.type)}`}
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>
                )}
                {removed && removed.length > 0 && (
                    <div className="text-red-600 text-center">
                        {removed.map((item: any, index: number) => (
                            <div
                                key={index}
                                data-tooltip-id="main-tooltip"
                                data-tooltip-content={item.type === "file" ? getRelativePath(item.path, projectName) : item.path}
                            >
                                {item.type === "url" ? (
                                    <a
                                        href={item.path}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => handleLinkClick(e, environment, vscode, item.path)}
                                    >
                                        {`- ${formatReference(item.path, item.type)}`}
                                    </a>
                                ) : (
                                    <a
                                        href={item.path}
                                        onClick={(e) => clickFileLink(e, environment, vscode, item.path)}
                                        className="text-red-600"
                                    >
                                        {`- ${formatReference(item.path, item.type)}`}
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MetadataContent;
